// import { Button } from '@/components/ui/button'
// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
//   DialogTrigger,
// } from '@/components/ui/dialog'
// import { useOrganizationMembers } from '@/hooks/organization'
// import { UserRoundIcon } from 'lucide-react'
// import { useMemo, useState } from 'react'
// import { Trans, useTranslation } from 'react-i18next'

export function AssignPersonDialog({
  assigneeId,
  onSelect,
}: {
  assigneeId: string
  onSelect: (userId: string | null) => void
}) {
  return null
  // const user = useUser()
  // const currentUser = user.user

  // const org = useOrganization({
  //   memberships: true,
  // })
  // const allUsers = useOrganizationMembers()
  // const users = useMemo(() => {
  //   const me = allUsers.filter((u) => u.id === currentUser?.id)
  //   const withoutMe = allUsers.filter((u) => u.id !== currentUser?.id)

  //   return [...me, ...withoutMe]
  // }, [allUsers, currentUser?.id])

  // const [open, setOpen] = useState(false)
  // const { t } = useTranslation()

  // const assignee = useMemo(() => {
  //   return users.find((u) => u.id === assigneeId)
  // }, [assigneeId, users])

  // // no org, no dialog
  // if (!org.isLoaded) return null
  // if (!org.organization) return null
  // if (users.length === 0) return null
  // if (users.length === 1) return null

  // const assigneeName = assignee
  //   ? assignee.id === currentUser?.id
  //     ? t('you')
  //     : assignee.name
  //   : t('checklists.assign')

  // return (
  //   <Dialog open={open} onOpenChange={setOpen}>
  //     <DialogTrigger asChild>
  //       <Button>
  //         <UserRoundIcon />
  //         {assigneeName}
  //       </Button>
  //     </DialogTrigger>
  //     <DialogContent className="sm:max-w-[425px] rounded-2xl">
  //       <DialogHeader>
  //         <DialogTitle>{t('checklists.assignChecklist')}</DialogTitle>
  //         <DialogDescription>
  //           <Trans
  //             i18nKey="checklists.assignChecklistDescription"
  //             components={{
  //               br: <br />,
  //             }}
  //           />
  //         </DialogDescription>
  //       </DialogHeader>
  //       <div className="flex flex-row gap-2 flex-wrap">
  //         {users.map((u) => {
  //           return (
  //             <div key={u.id}>
  //               <Button
  //                 variant="secondary"
  //                 className="py-6 px-3 flex items-center gap-2"
  //                 onClick={() => {
  //                   onSelect(u.id)
  //                   setOpen(false)
  //                 }}
  //               >
  //                 <img
  //                   src={u.image}
  //                   alt={u.name}
  //                   className="w-8 h-8 rounded-full"
  //                 />
  //                 <div>{u.id === currentUser?.id ? t('you') : u.name}</div>
  //               </Button>
  //             </div>
  //           )
  //         })}
  //       </div>
  //       <DialogFooter className="!justify-between">
  //         <Button
  //           variant="secondary"
  //           type="button"
  //           onClick={() => setOpen(false)}
  //         >
  //           {t('back')}
  //         </Button>
  //         {Boolean(assigneeId) && (
  //           <Button
  //             variant={'destructive'}
  //             type="button"
  //             onClick={() => {
  //               onSelect(null)
  //               setOpen(false)
  //             }}
  //           >
  //             {t('checklists.unassign')}
  //           </Button>
  //         )}
  //       </DialogFooter>
  //     </DialogContent>
  //   </Dialog>
  // )
}
